<template>
  <div>
    <myHeader class="my-header" @data-meau="handleDataMeau"></myHeader>

    <div class="demo-collapse">
      <div class="page-title">在线反馈</div>

      <div class="feedback-title">
        <strong>我们希望听到您的声音！</strong><br />
        •如果您有任何问题（建议、意见、咨询、业务合作、索取资料、友情链接等），请通过以下方式联系我们，我们会尽快给您回复。<br />
        •如果您有任何业务联系或技术支持想给我们留言，您也可以通过以下方法更直接地联系我们。<br />
      </div>

      <div :class="meau ? 'meau-show' : ''">
        <input
          type="text"
          v-model="name"
          class="input"
          placeholder="姓名"
        /><br /><br />
        <input v-model="phone" placeholder="手机号" class="input" /><br /><br />
        <textarea
          v-model="message"
          class="textarea"
          type="textarea"
          placeholder="您的需求描述"
        ></textarea
        ><br /><br />
        <button type="primary" @click="sendTo" class="input send" value="send">
          提交</button
        ><br /><br />
      </div>

      <!-- 地图 -->

      <!-- <div id="bdmap"></div> -->
    </div>

    <myFooter class="footer"></myFooter>
  </div>
</template>

<script>
import myFooter from "../components/myFooter.vue";
import myHeader from "../components/myHeader.vue";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      name: "",
      subject: "",
      phone: "",
      message: "",

      meau: false,
    };
  },
  components: {
    myFooter,
    myHeader,
  },

  mounted() {
    this.$nextTick(() => {
      // 创建地图实例
      /* eslint-disable no-undef */

      const map = new BMap.Map(this.$refs.bdmap);
      const point = new BMap.Point(116.404, 39.915);
      map.centerAndZoom(point, 15);

      // 添加控件
      map.addControl(new BMap.NavigationControl());

      // 添加标记
      const marker = new BMap.Marker(point);
      map.addOverlay(marker);
      /* eslint-enable no-undef */
    });
  },

  methods: {
    sendTo() {
      if (this.name == "") {
        ElMessage.error("请输入您的姓名");
        return;
      }
      if (this.phone == "") {
        ElMessage.error("请输入您的手机号");
        return;
      }

      this.$axios({
        method: "post",
        url: "/api/feedback/client/createFeedback",
        data: {
          name: this.name,
          phone: this.phone,
          message: this.message,
        },
      }).then((res) => {
        if (res.data.code === 0) {
          ElMessage({
            message: "提交成功!",
            type: "success",
          });
        }
      });
    },

    handleDataMeau(data) {
      console.log(data);
      // this.meau = data;
    },
  },
};
</script>

<style lang="less" scoped>
.demo-collapse {
  margin-top: 90px;
  padding: 0 30vw;
}

#bdmap {
  width: 200px;
  height: 200px;
}

.meau-show {
  display: none;
}

.page-title {
  font-size: 40px;
  font-weight: 700;
  line-height: 100px;
  height: 100px;
  text-align: center;
}
.feedback-title {
  line-height: 40px;
  margin-bottom: 20px;
}

.input {
  width: 100%;
  padding: 0 10px;
  height: 45px;
  border-radius: 5px;
  border: 1px solid #999;
}

.textarea {
  height: 180px;
  line-height: 45px;
  width: 100%;
  padding: 0 10px;
  border-radius: 5px;
  border: 1px solid #999;
}

.send {
  background-color: #d92b35;
  border: #d92b35;
  color: white;
  border: none;
}

.footer {
  //   position: absolute;
  bottom: 0;
  width: 100%;
}

@media (max-width: 768px) {
  .page-title {
    font-size: 36px !important;
  }

  .demo-collapse {
    padding: 2vw !important;
  }

  .footer {
    position: relative !important;
    bottom: 0;
    width: 100%;
  }
}
</style>
